import { jsx as _jsx } from "react/jsx-runtime";
import { FormLookup } from '@/core/ui';
import { useGetStockListQuery } from '@/warehouse/modules/stocks/business';
const StockFormLookup = ({ skipQuery, name, disabled, control, onBeforeChange }) => {
    const { data, isLoading } = useGetStockListQuery(undefined, { skip: skipQuery !== false });
    return (_jsx(FormLookup, { items: data, isLoading: isLoading, keyField: "id", labelField: "name", control: control, name: name, 
        // `|| true` - currently stock should not be changed.
        disabled: disabled || true, onBeforeChange: onBeforeChange }));
};
export { StockFormLookup };
